import { DEFAULT_QUERY_PARAMS } from '../models/query-params';
import { TableQueryParams } from '../services/table-query-params.service';
import { debounce } from '../utils/debounce';

/**
 * Transfer package mixin.
 * @param {object} params Query param.
 * @param {import('vue').Ref<TableQueryParams>} params.queryParams Query param.
 * @param {Function} params.prepareLearners Prepare learners.
 */
export function transferPackageMixin({ queryParams, prepareLearners }) {
  /**
   * Search learners with debounce helper.
   * @param {Function} prepareLearners
   * @returns {Function}
   */
  const debouncePrepareLearners = debounce(async () => {
    await prepareLearners();
  });

  /**
   * Handle search user's name
   * @param {string} value Search string
   * @param prepareLearners
   */
  function onSearchChange(value) {
    if (value != null) {
      queryParams.value.page = DEFAULT_QUERY_PARAMS.page;
      queryParams.value.searchString = value;
      debouncePrepareLearners();
    }
  }

  /** Reset query params. */
  function resetPageQueryParams() {
    queryParams.value.page = DEFAULT_QUERY_PARAMS.page;
    queryParams.value.searchString = '';
  }

  /**
   * Handle visibility filter change.
   * @param {object} value Visibility.
   */
  function onVisibilityChange(value) {
    queryParams.value.page = DEFAULT_QUERY_PARAMS.page;
    queryParams.value.visibility = value;
    prepareLearners();
  }

  /**
   * Handle pagination change.
   * @param {object} options Next page.
   */
  function onPageChange(options) {
    queryParams.value.page = options.page;
    queryParams.value.perPage = options.perPage;
    debouncePrepareLearners();
  }

  return {
    onSearchChange,
    resetPageQueryParams,
    onPageChange,
    onVisibilityChange,
  };
}
